module.exports = __webpack_public_path__ + "static/media/email.c06d8165.gif";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/gifs/email.gif
// module id = 69
// module chunks = 0